import React, { useEffect, useState } from 'react';
import { CalendarView } from '@stencil/dcalendar';
import * as S from './MobileHeader.style';
import dateFormat from 'dateformat';
import getDateObj from '../../Common/utils/GetDateObj';
import { redirectToFunnel } from '../../Common/utils/redirectToFunnel';
const MWebCalendarWrapper = (props) => {
    const todaysDate = getDateObj();
    const maxDateAllowed = getDateObj();
    maxDateAllowed.setMonth(maxDateAllowed.getMonth() + 12);
    const { src, dest, src_id, dest_id, page, showCalendar, changeCalendar, dateObj, date, operatorId='', operatorName='' } = props

    const [selectedDate, setSelectedDate] = useState(dateObj);
    const dateOnClickHandler = dateObj => {
        const year = dateObj.getFullYear();
        const month = ('0' + (dateObj.getMonth() + 1)).slice(-2)
        const day = ('0' + dateObj.getDate()).slice(-2);
        const customDate = `${year}${month}${day}`
        setSelectedDate(customDate)
        changeCalendar()
        if (src && dest && src_id && dest_id) {
            redirectToFunnel({
                page: page, data: {
                    src_name: src,
                    dest_name: dest,
                    src_vid: src_id,
                    dest_vid: dest_id
                }, data_date: customDate,
                operatorId,
                operatorName,
                isFilter: true
            });
        };
    }
    const getClassName = (dateObj: Date) => {
        const types = ['selectedDate', 'leftactive', 'rightactive', 'partial'];
        return types[0];
    };
    return (
        <S.CalendarBlockOuterWrapper>
            <CalendarView
                dateConfigForMonthToBeDisplayed={selectedDate || todaysDate}
                minDateAllowed={todaysDate}
                maxDateAllowed={maxDateAllowed}
                renderDateItem={({ value, dateObj, index }) => {
                    if (!value) {
                        return (
                            <li key={"empty" + index}>
                                <span></span>
                            </li>
                        );
                    }


                    let isValid = true;

                    dateObj.setHours(0, 0, 0, 0);

                    todaysDate.setHours(0, 0, 0, 0);
                    isValid =
                        dateObj.getTime() >= todaysDate.getTime() &&
                        dateObj.getTime() < maxDateAllowed.getTime();

                    return (
                        <li
                            className={
                                dateFormat(selectedDate, 'dmmyyyy') === dateFormat(dateObj, 'dmmyyyy')
                                    ? getClassName(dateObj)
                                    : ''
                            }
                            key={value + dateObj.getTime()}
                            style={isValid ? { color: 'black' } : { opacity: '0.4', color: 'grey' }}
                            onClick={() => {
                                isValid ? dateOnClickHandler(dateObj) : () => { };
                            }}
                        >
                            <span>{value}</span>
                        </li>
                    );
                }}
            />
        </S.CalendarBlockOuterWrapper>
    )
}
export default MWebCalendarWrapper
